import { render, staticRenderFns } from "./DealsManagement.vue?vue&type=template&id=32a3e0ac&scoped=true&"
import script from "./DealsManagement.vue?vue&type=script&lang=ts&"
export * from "./DealsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./DealsManagement.vue?vue&type=style&index=0&id=32a3e0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3e0ac",
  null
  
)

export default component.exports